import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getMinimalExportObject, ObjectMode } from '@iotv/io';
import { minmalBOToVob } from '@iotv/iotv-v3-types';
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Stack } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { AppMainViewContext } from '../../ContextProviders/AppContextProvider';
import { MultipleEntityAutoQuery } from '../generic/EntityAutoQuery';
export const useExportControls = ({ disabled }) => {
    const [{ contextCustomer, isSmallView }] = useContext(AppMainViewContext);
    const [objectMode, setObjectMode] = useState(ObjectMode.Hierarchy);
    const [type, setType] = useState('Customer');
    const [objects, setObjects] = useState(contextCustomer ? [contextCustomer] : []);
    const [exportObjects, setEObjects] = useState(contextCustomer ? [getMinimalExportObject(contextCustomer)] : []);
    useEffect(() => {
        setObjects([]);
        setEObjects([]);
    }, [type, objectMode]);
    useEffect(() => {
        if (contextCustomer && objectMode === ObjectMode.Hierarchy && type === 'Customer') {
            setObjects([contextCustomer]);
        }
    }, [contextCustomer?.sk, objectMode, type]);
    useEffect(() => {
        setEObjects(objects.map(getMinimalExportObject));
    }, [objects]);
    const setExportObjects = (objectList) => {
        setObjects(objectList.map((o) => minmalBOToVob(o)));
    };
    const controls = (_jsxs(FormControl, { children: [_jsx(FormLabel, { children: "Data" }), _jsxs(RadioGroup, { value: type, onChange: (_, v) => setType(v), row: !isSmallView, children: [_jsx(FormControlLabel, { label: 'Customer', control: _jsx(Radio, {}), value: 'Customer', disabled: disabled }), _jsx(FormControlLabel, { label: 'Property', control: _jsx(Radio, {}), value: 'Property', disabled: disabled })] }), _jsx(Stack, { direction: "row", marginBlockStart: 1, spacing: 1, children: objectMode === ObjectMode.Hierarchy && type === 'Property' && (_jsx(MultipleEntityAutoQuery, { contextObject: contextCustomer, entityType: type, currentEntities: objects, setCurrentEntities: setObjects, 
                    // closeOnSelect={false}
                    fullWidth: false, required: true })) })] }));
    return {
        controls,
        objectMode,
        setObjectMode,
        exportObjects,
        setExportObjects,
    };
};
